<template>
  <Menu as="div" class="relative z-50 ml-6">
    <MenuButton class="block flex items-center space-x-2">
      <div
        class="
          w-[45px]
          h-[45px]
          rounded-full
          border-4 border-gray-200
          overflow-hidden
        "
      >
        <img :src="profileImage" :alt="auth.name" class="object-contain" />
      </div>
      <span
        class="text-sm font-medium text-white"
        >{{ auth.name }}</span
      >
    </MenuButton>
    <MenuItems class="absolute origin-top-right right-0 mt-2">
      <div class="relative">
        <div
          class="invisible absolute inset-0 bg-blue-500 blur opacity-50"
        ></div>
        <div
          class="relative w-64 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none overflow-hidden"
        >
          <MenuItem v-slot="{ active }">
            <Link
              class="block py-2.5 px-4 text-sm"
              :class="{
                'bg-gray-200 text-gray-900': active,
              }"
              :href="route('profile')"
            >
              My Profile
            </Link>
          </MenuItem>
          <MenuItem v-slot="{ active }">
            <Link
              class="block py-2.5 px-4 text-sm"
              :class="{
                'bg-gray-200 text-gray-900': active,
              }"
              :href="route('profile.settings')"
            >
              Settings
            </Link>
          </MenuItem>
          <MenuItem v-slot="{ active }">
            <Link
              class="block py-2.5 px-4 text-sm"
              :class="{
                'bg-gray-200 text-gray-900': active,
              }"
              :href="route('saved-jobs')"
            >
              Saved Jobs
            </Link>
          </MenuItem>
          <div class="border-t"></div>
          <MenuItem disabled>
            <span
              class="block py-2.5 px-4 text-sm opacity-75"
              >Invite a friend (coming soon!)</span
            >
          </MenuItem>
          <div class="border-t"></div>
          <MenuItem v-slot="{ active }">
            <button
              type="button"
              @click="logout"
              class="w-full text-left py-2.5 px-4 text-sm"
              :class="{
                'bg-gray-200 text-gray-900': active,
              }"
            >
              Logout
            </button>
          </MenuItem>
        </div>
      </div>
    </MenuItems>
  </Menu>
</template>

<script>
import { computed } from "vue";
import { Link } from "@inertiajs/inertia-vue3";
import { Inertia } from "@inertiajs/inertia";
import { Menu, MenuButton, MenuItems, MenuItem } from "@headlessui/vue";
import md5 from "md5";

export default {
  props: {
    auth: Object,
  },

  setup(props) {
    const profileImage = computed(() => {
      if (props.auth.profile_pic) {
        return '/storage/' + props.auth.profile_pic;
      }

      const hash = md5(props.auth.email);

      return `https://www.gravatar.com/avatar/${hash}`;
    });

    const route = window.route;

    const logout = () => {
      Inertia.post(route("logout"));
    };

    return { route, logout, profileImage };
  },

  components: {
    Link,
    Menu,
    MenuButton,
    MenuItems,
    MenuItem,
  },
};
</script>
